import { transparentize } from 'polished';
import React from 'react';

import type { DsrIconProps } from './wrappers';
import { Svg } from './wrappers';

const Icon = ({
  primaryColor,
  selectedColor,
  selected,
  ...svgProps
}: DsrIconProps): JSX.Element => (
  <Svg viewBox="0 0 24 24" version="1.1" {...svgProps}>
    <title>DSR/icon/erase:default</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M 16 15 L 17 15 L 17 4 L 6 4 L 6 20 L 15 20 L 15 16 C 15 15.398438 15.398438 15 16 15 Z M 16 15 "
        fill={selected ? selectedColor : transparentize(0.7, primaryColor)}
        fillRule="nonzero"
      />
      <path
        d="M 11 18 L 9 18 L 9 7 L 11 7 Z M 15 18 L 13 18 L 13 7 L 15 7 Z M 4 3 L 20 3 L 20 5 L 4 5 Z M 4 3 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        d="M 17 5 L 14 2 L 10 2 L 7 5 Z M 17 5 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        d="M 15 22 L 7 22 C 5.898438 22 5 21.101562 5 20 L 5 3 L 19 3 L 19 15 L 17 15 L 17 5 L 7 5 L 7 20 L 15 20 Z M 15 22 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        d="M 16.488281 18.367188 L 17.902344 16.953125 L 23.558594 22.609375 L 22.144531 24.023438 Z M 16.488281 18.367188 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        d="M 16.488281 22.609375 L 22.144531 16.953125 L 23.558594 18.367188 L 17.902344 24.023438 Z M 16.488281 22.609375 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
    </g>
  </Svg>
);

export default Icon;
